import { default as ReadySwitch, StatesReadySwitch } from 'components/layout/ReadySwitch';

export default {
  ReadySwitch,
  StatesReadySwitch,
};



// WEBPACK FOOTER //
// src/components/layout/index.js